import React from "react";
import "../styling/biotiles.css";
import { isMobile } from "react-device-detect";

// This function takes name and bio as props passed to it. The lorem is merely placeholder text to see how it looks.
// See the example in the Members.js

function NewLineText(bio) {
  let splitLines = bio.split(`\\n`);
  const finalLines = splitLines.map((number, ind) => (
    <span key={ind}>
      {number}
      {ind < splitLines.length - 1 && <br />}
    </span>
  ));
  return finalLines;

  //return <p>test \nsj</p>
}

// Helper function to load images dynamically
const getImageSrc = (imageName) => {
  try {
    return require(`../assets/GroupPhotos/${imageName}`);
  } catch (error) {
    console.error(`Failed to load image: ${imageName}`, error);
    return null;
  }
};

// Helper function to render year joined field
const renderYearJoined = (yearJoined) => {
  if (!yearJoined) return null;
  
  const label = yearJoined.includes('-') ? 'Years: ' : 'Year Joined: ';
  
  return (
    <>
      <p>{label}</p>
      <p>{yearJoined}</p>
    </>
  );
};

const Bio = ({ person }) => {
  /*const lorem = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
    Nunc gravida elementum blandit. 
    Nulla elit ante, malesuada sit amet convallis eu, laoreet quis lectus. 
    Curabitur in urna elit. Donec leo erat, sollicitudin gravida mauris mattis, malesuada blandit nunc. 
    Ut gravida ut nunc non vulputate. 
    Pellentesque non orci odio. 
    Nullam imperdiet elit rhoncus justo fermentum, ac bibendum leo fermentum. 
    Vivamus at justo nec mauris pulvinar euismod sed eu lacus. 
    Duis vitae orci et enim vestibulum rhoncus ut a nulla.`
    */
  
  const imageSrc = getImageSrc(person.image);
  
  if (isMobile) {
    return (
      <div className="Tile-Container-Mobile">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={person.name || "Group member"}
            onError={(e) => {
              console.error(`Image failed to load: ${person.image}`);
              e.target.style.display = 'none';
            }}
          />
        )}
        <div>
          <p style={{ fontSize: "2em", marginBottom: "0", marginTop: "10px" }}>
            {person.name}
          </p>
          <div className="Tile-Element-Container-Mobile">
            <p>Hometown: </p>
            <p>{person.hometown}</p>
          </div>
          <div className="Tile-Element-Container-Mobile">
            {renderYearJoined(person.year_joined)}
          </div>
          <div className="Tile-Element-Container-Mobile">
            <p>Status: </p>
            <p>{person.status}</p>
          </div>
          <div className="Tile-Element-Container-Bio">
            {/* 
            <p>About Me: </p>
            */}
            <p>{NewLineText(person.about_me)}</p>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="Tile-Container">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={person.name || "Group member"}
            onError={(e) => {
              console.error(`Image failed to load: ${person.image}`);
              e.target.style.display = 'none';
            }}
          />
        )}
        <div>
          <p style={{ fontSize: "2em", marginBottom: "0", marginTop: "10px" }}>
            {person.name}
          </p>
          <div className="Tile-Element-Container">
            <p>Hometown: </p>
            <p>{person.hometown}</p>
          </div>
          <div className="Tile-Element-Container">
            {renderYearJoined(person.year_joined)}
          </div>
          <div className="Tile-Element-Container">
            <p>Status: </p>
            <p>{person.status}</p>
          </div>
          <div className="Tile-Element-Container-Bio">
            <p>{NewLineText(person.about_me)}</p>
          </div>
        </div>
      </div>
    );
  }
};

export default Bio;
